import { GridApi } from 'ag-grid-community';
import { BudgetProposalT } from 'routes/BudgetModule/config/types';

export type LoadingBudgetProposalT = BudgetProposalT & { isLoading?: boolean };

export const refreshBudgetProposalRow = (
    gridApi: GridApi,
    bpId: number,
    updater: (bp: LoadingBudgetProposalT) => LoadingBudgetProposalT,
) => {
    const itemsToUpdate: LoadingBudgetProposalT[] = [];
    gridApi.forEachNodeAfterFilterAndSort((rowNode) => {
        const { data } = rowNode;
        if (data.id === bpId) {
            // The Object.assign is important because AgGrid uses object reference
            // to match objects. That's why we need to keep the same reference.
            itemsToUpdate.push(Object.assign(data, updater(data)));
        }
    });
    gridApi.applyTransaction({ update: itemsToUpdate });
    gridApi.refreshCells({ force: true });
};
